import { LayoutsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useLayoutsAPI(): LayoutsApi {
  return new LayoutsApi(apiConfig);
}
